import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "Introduction" }
const _hoisted_2 = { id: "Apps" }
const _hoisted_3 = { id: "Essays" }
const _hoisted_4 = { id: "Podcasts" }
const _hoisted_5 = { id: "Projects" }
const _hoisted_6 = { id: "Contact" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_IntroComponent = _resolveComponent("IntroComponent")!
  const _component_InterestsComponent = _resolveComponent("InterestsComponent")!
  const _component_LinksComponent = _resolveComponent("LinksComponent")!
  const _component_StartupsComponent = _resolveComponent("StartupsComponent")!
  const _component_EssaysComponent = _resolveComponent("EssaysComponent")!
  const _component_PodcastsComponent = _resolveComponent("PodcastsComponent")!
  const _component_ProjectsComponent = _resolveComponent("ProjectsComponent")!
  const _component_CollaborationsComponent = _resolveComponent("CollaborationsComponent")!
  const _component_SkillsComponent = _resolveComponent("SkillsComponent")!
  const _component_ContactComponent = _resolveComponent("ContactComponent")!
  const _component_ScrollToTopComponent = _resolveComponent("ScrollToTopComponent")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            lg: "6",
            "offset-lg": "3"
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createElementVNode("a", { href: "#top" }, null, -1)),
              _createElementVNode("section", _hoisted_1, [
                _createVNode(_component_HeaderComponent, { class: "pt-8" })
              ])
            ]),
            _: 1,
            __: [0]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-16" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            lg: "10",
            "offset-lg": "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: "/img/andromeda-technology-overview.png",
                contain: ""
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            lg: "8",
            "offset-lg": "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IntroComponent, { class: "mt-16 py-16" }),
              _createVNode(_component_InterestsComponent, { class: "my-16 py-16" }),
              _createVNode(_component_LinksComponent, { class: "mb-16 py-16" }),
              _createElementVNode("section", _hoisted_2, [
                _createVNode(_component_StartupsComponent, { class: "py-16" })
              ]),
              _createElementVNode("section", _hoisted_3, [
                _createVNode(_component_EssaysComponent, { class: "py-16" })
              ]),
              _createElementVNode("section", _hoisted_4, [
                _createVNode(_component_PodcastsComponent, { class: "py-16" })
              ]),
              _createElementVNode("section", _hoisted_5, [
                _createVNode(_component_ProjectsComponent, { class: "py-16" })
              ]),
              false
                ? (_openBlock(), _createBlock(_component_CollaborationsComponent, {
                    key: 0,
                    class: "py-16"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_6, [
                _createVNode(_component_SkillsComponent, { class: "mt-8" }),
                _createVNode(_component_ContactComponent, { class: "pb-16 mb-16" })
              ]),
              _createVNode(_component_ScrollToTopComponent, { class: "py-16 my-16" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}